import { jsx as i } from "react/jsx-runtime";
import { isValidFormInputElement as n } from "../../../helpers/form/isValidFormInputElement.js";
import { ValidationBase as s } from "../ValidationBase/ValidationBase.js";
const u = ({
  linkToTarget: e,
  ...o
}) => /* @__PURE__ */ i(
  s,
  {
    ...o,
    as: "a",
    href: `#${e}`,
    onClick: (r) => {
      const t = document.getElementById(e);
      t && (r.preventDefault(), n(t) ? t.focus() : (t.setAttribute("tabIndex", "-1"), t.focus(), t.removeAttribute("tabIndex")));
    }
  }
);
export {
  u as IressValidationLink
};
